export default "__VITE_ASSET__BUT2ai$B__"